import React from "react";
import styles from "./routesBar.module.scss";
import SideBarInner from "../../../shared/sideBarInner";
import SideBarControl from "../../sides/sideBarControl";
import RoutesTitleClosedBar from "../reports/routesTitleClosedBar";
import TitleBarWrapper from "../../../shared/titleBarWrapper";
import FirstTitle from "../../../shared/items/static/firstTitle";
import RoutesListWrapper from "../cars/routesListWrapper";
import SearchRoutesString from "../cars/serchRouteString";
import { withRoutes } from "../../../shared/containers/containerRoutes";
import CreateRoutePanel from "../cars/createRoutePanel";
import RoutesSwitcher from "./routesSwitcher";

const RoutesBar = (props) => {
  const { count, totalCount } = props;

  return (
    <div className={styles.sideBarsWrapper}>
      <SideBarControl TitleClosed={<RoutesTitleClosedBar />}>
        <div className={styles.routesBar}>
          <SideBarInner>
            <TitleBarWrapper>
              <FirstTitle>Маршруты</FirstTitle>
            </TitleBarWrapper>
          </SideBarInner>

          <SideBarInner>
            <RoutesSwitcher />
          </SideBarInner>

          <SideBarInner>
            <SearchRoutesString />
          </SideBarInner>

          <SideBarInner>
            <CreateRoutePanel />
          </SideBarInner>

          <SideBarInner>
            <div className={styles.container_routesList}>
              {totalCount === count ? (
                <div>
                  Всего: <b>{totalCount}</b>
                </div>
              ) : (
                <div>
                  <b>{count}</b> из <b>{totalCount}</b>
                </div>
              )}

              <RoutesListWrapper />
            </div>
          </SideBarInner>
        </div>
      </SideBarControl>
    </div>
  );
};

export default withRoutes(React.memo(RoutesBar));
